// extracted by mini-css-extract-plugin
export default {"page":"HW-z","cartModal":"IW-z","checkout":"JW-z","placeholder":"KW-z","account":"LW-z"};